module.exports = __webpack_public_path__ + "media/V24.0dc5d699.mp4";